
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiComRadioEmergency as ObiComRadioEmergencyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-com-radio-emergency.js';
 
 
 

 
 export const ObiComRadioEmergency = createComponent({
   react: React,
   tagName: 'obi-com-radio-emergency',
   elementClass: ObiComRadioEmergencyElement,
   events: {
     
   }
  });
 
 